<template>
  <div class="posRel">
    <button
      ref="toolTip"
      class="tool-tip"
      :class="{ 'tool-tip-arrow-mobile': showPopup }"
      @click="showPopup = !showPopup"
    >
      <span class="material-icons-outlined tool-tip-icon">info</span>
    </button>
    <div
      class="tool-tip-text"
      v-show="showPopup"
      v-closable="{
        exclude: ['toolTip'],
        handler: 'onClose'
      }"
    >
      <div class="tool-tip-arrow">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = e => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      if (el && !el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },
  unbind() {
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
});

export default {
  name: "ToolTip",
  components: {},
  data() {
    return { showPopup: false };
  },
  methods: {
    onClose() {
      this.showPopup = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin desktopToolTipPosition {
  bottom: 40px;
  margin-left: -149px;
  left: 50%;
}
@mixin mobileToolTipSetLeft {
  margin-left: -7px;
  left: auto;
}
@mixin tabletMarginLeft {
  margin-left: -79px;
}
.tool-tip-arrow-mobile {
  @include media-breakpoint-between(xs, sm) {
    &::after {
      content: "";
      width: 20px;
      height: 20px;
      transform: rotate(-45deg);
      background: #fff;
      position: absolute;
      box-shadow: -1px 3px 10px 3px white, -2px 3px 2px black;
      z-index: 10001;
      bottom: 32px;
      left: calc(50% - 10px);
    }
  }
}
.tool-tip {
  background: none;
  border: none;
  padding: 0px;
  cursor: pointer;
}

.chrome .tool-tip-text {
  @include desktopToolTipPosition;

  @include media-breakpoint-between(md, lg) {
    @include tabletMarginLeft;
  }
  @include media-breakpoint-between(xs, sm) {
    bottom: 17px;
    @include mobileToolTipSetLeft;
  }
}

.safari .tool-tip-text {
  @include desktopToolTipPosition;

  @include media-breakpoint-between(md, lg) {
    @include tabletMarginLeft;
  }
  @include media-breakpoint-between(xs, sm) {
    bottom: 41px;
    @include mobileToolTipSetLeft;
  }
}

.firefox .tool-tip-text {
  @include desktopToolTipPosition;

  @include media-breakpoint-between(md, lg) {
    @include tabletMarginLeft;
  }
  @include media-breakpoint-between(xs, sm) {
    bottom: 39px;
    margin-left: -7px;
    left: auto;
  }
}

.ie .tool-tip-text {
  @include desktopToolTipPosition;

  @include media-breakpoint-between(md, lg) {
    @include tabletMarginLeft;
  }
}

.tool-tip-text {
  position: absolute;
  background: none;
  border: 1px solid #d8d8d8;
  border-radius: 0px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);
  color: #666766;
  z-index: 10000;
  font-size: 14px;
  letter-spacing: 0.25px;
  background: white;
  @include media-breakpoint-up(md) {
    width: 298px;
  }
  @include media-breakpoint-between(xs, sm) {
    width: 210px;
  }

  &::after {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(-45deg);
    background: #fff;
    position: absolute;
    box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
    z-index: -1;
    bottom: -10px;
    left: calc(50% - 10px);
    @include media-breakpoint-between(md, lg) {
      left: calc(50% - 80px);
    }
    @include media-breakpoint-between(xs, sm) {
      display: none;
    }
  }
}

.tool-tip-arrow {
  background: white;
  padding: 10px;
}

.tool-tip-icon {
  font-size: 16px;
}

.posRel {
  position: relative;
  display: inline;
  width: 30px;
}
</style>
